import React from "react";
import PostgradHeader from "./PostgradHeader";
import PostgradFooter from "./PostgradFooter";
import "./postgrad-portal.css";

const PostgradLayout = ({ children }) => {
  return (
    <div className="pg-portal flex min-h-screen flex-col bg-[#f3f7fb] text-slate-900">
      <PostgradHeader />
      <main className="pg-portal-main flex-1">
        {children}
      </main>
      <PostgradFooter />
    </div>
  );
};

export default PostgradLayout;
